import React from 'react';
import { Button } from '@mui/material';
import { getApiRoot } from '../../utils/api';

/**
 * Google's mark, inlined rather than fetched so the button cannot render without
 * it. The four colours are fixed by Google's branding rules.
 */
const GoogleMark = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">
    <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92a8.78 8.78 0 0 0 2.68-6.62Z" />
    <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.34A9 9 0 0 0 9 18Z" />
    <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.94H.96a9 9 0 0 0 0 8.12l3.01-2.34Z" />
    <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59A9 9 0 0 0 .96 4.94l3.01 2.34C4.68 5.16 6.66 3.58 9 3.58Z" />
  </svg>
);

/**
 * Starts the redirect flow. Nothing is posted: the server owns the exchange with
 * Google and hands back a token, so this only has to leave the app.
 *
 * @param {string} [redirectPath] where to land afterwards, e.g. an invite page
 */
const GoogleSignInButton = ({ redirectPath, label = 'Continue with Google', disabled = false }) => {
  const start = () => {
    const url = new URL(`${getApiRoot()}/api/auth/google`);
    if (redirectPath) url.searchParams.set('redirect', redirectPath);
    window.location.href = url.toString();
  };

  return (
    <Button
      fullWidth
      variant="outlined"
      size="large"
      onClick={start}
      disabled={disabled}
      startIcon={<GoogleMark />}
      sx={{
        // Google asks for a light surface and its own wordmark treatment, so this
        // deliberately steps outside the app's dark palette.
        backgroundColor: '#fff',
        color: '#1f1f1f',
        borderColor: '#dadce0',
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': { backgroundColor: '#f7f8f8', borderColor: '#d2d5d9' },
      }}
    >
      {label}
    </Button>
  );
};

export default GoogleSignInButton;
